import React from 'react';
import { Conversation } from '../types';
import { formatRelativeTime } from '../utils/date';

interface ConversationListProps {
    conversations: Conversation[];
    currentConversationId: string;
    onSelect: (id: string) => void;
    onDelete: (id: string) => void;
    onNewConversation: () => void;
}

const ConversationList: React.FC<ConversationListProps> = ({
    conversations,
    currentConversationId,
    onSelect,
    onDelete,
    onNewConversation,
}) => {
    return (
        <div className="h-full flex flex-col bg-background-secondary dark:bg-dark-background-secondary backdrop-blur-sm border-r border-glass-border dark:border-dark-glass-border">
            <div className="p-4 border-b border-glass-border dark:border-dark-glass-border flex items-center justify-between">
                <h2 className="text-lg font-semibold bg-gradient-to-r from-primary-light to-secondary bg-clip-text text-transparent">
                    Versetaille
                </h2>
                <button
                    onClick={onNewConversation}
                    className="p-2 rounded-lg bg-background-tertiary dark:bg-dark-background-tertiary hover:bg-primary/20 dark:hover:bg-dark-primary/20 transition-colors"
                    aria-label="New conversation"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                    </svg>
                </button>
            </div>

            <div className="flex-1 overflow-y-auto py-2 space-y-1 px-2">
                {conversations.length === 0 ? (
                    <div className="text-center py-8 text-gray-400 dark:text-gray-500 italic">
                        No conversations yet
                    </div>
                ) : (
                    conversations.map((conversation) => (
                        <div
                            key={conversation.id}
                            className={`
                group flex items-center justify-between p-3 rounded-xl cursor-pointer transition-all
                ${currentConversationId === conversation.id
                                    ? 'bg-background-tertiary dark:bg-dark-background-tertiary border border-glass-shine dark:border-dark-glass-shine'
                                    : 'hover:bg-background-tertiary/70 dark:hover:bg-dark-background-tertiary/70'
                                }
              `}
                            onClick={() => onSelect(conversation.id)}
                        >
                            <div className="flex-1 min-w-0">
                                <div className="font-medium truncate text-text-primary dark:text-dark-text-primary">
                                    {conversation.title}
                                </div>
                                <div className="text-xs text-text-secondary dark:text-dark-text-secondary flex items-center space-x-2">
                                    <span>{formatRelativeTime(conversation.updatedAt)}</span>
                                    <span>•</span>
                                    <span>{conversation.messages.length} messages</span>
                                </div>
                            </div>

                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onDelete(conversation.id);
                                }}
                                className="opacity-0 group-hover:opacity-100 p-1.5 rounded-md hover:bg-red-500/20 text-gray-400 dark:text-gray-500 hover:text-red-400 dark:hover:text-red-300 transition-all"
                                aria-label="Delete conversation"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-4 w-4"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <polyline points="3 6 5 6 21 6"></polyline>
                                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                </svg>
                            </button>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default ConversationList; 